import { render, staticRenderFns } from "./SidebarCheckboxesFilter.vue?vue&type=template&id=2d973913&"
import script from "./SidebarCheckboxesFilter.vue?vue&type=script&lang=js&"
export * from "./SidebarCheckboxesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
